import { individuos } from "@/mocks/cta";

export default function TreePriorityPanel() {
  const hoje = new Date("2026-07-01");
  const emergencial = individuos.filter((i) => i.recomendacao === "Poda emergencial");
  const supressao = individuos.filter((i) => i.recomendacao === "Supressão");
  const semFoto = individuos.filter((i) => i.fotos === 0);
  const semEspecie = individuos.filter((i) => i.tipo === "Não identificado");
  const semValidacao = individuos.filter((i) => i.statusRevisao !== "validada" && i.statusRevisao !== "arquivada");

  const prioridades = [
    {
      label: "Árvores críticas sem vistoria recente",
      count: individuos.filter((i) => i.classeRisco === "critico" && new Date(i.ultimaVistoria) < new Date("2026-05-01")).length,
      color: "border-l-danger-500 bg-danger-50/50",
      textColor: "text-danger-700",
      icon: "ri-close-circle-line",
      iconColor: "text-danger-600",
    },
    {
      label: "Poda emergencial",
      count: emergencial.length,
      color: "border-l-danger-500 bg-danger-50/50",
      textColor: "text-danger-700",
      icon: "ri-scissors-cut-line",
      iconColor: "text-danger-600",
    },
    {
      label: "Supressão recomendada",
      count: supressao.length,
      color: "border-l-danger-500 bg-danger-50/50",
      textColor: "text-danger-700",
      icon: "ri-alert-line",
      iconColor: "text-danger-600",
    },
    {
      label: "Registros sem foto",
      count: semFoto.length,
      color: "border-l-warning-500 bg-warning-50/50",
      textColor: "text-warning-700",
      icon: "ri-camera-off-line",
      iconColor: "text-warning-600",
    },
    {
      label: "Sem espécie identificada",
      count: semEspecie.length,
      color: "border-l-caution-500 bg-caution-50/50",
      textColor: "text-caution-700",
      icon: "ri-question-line",
      iconColor: "text-caution-600",
    },
    {
      label: "Sem validação técnica",
      count: semValidacao.length,
      color: "border-l-warning-500 bg-warning-50/50",
      textColor: "text-warning-700",
      icon: "ri-shield-user-line",
      iconColor: "text-warning-600",
    },
  ];

  return (
    <div className="bg-white rounded-card border border-background-200 p-5">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 rounded-lg bg-warning-100 flex items-center justify-center">
          <i className="ri-flag-line text-warning-600 text-sm"></i>
        </div>
        <h3 className="text-sm font-semibold text-foreground-900 font-heading">Prioridades do CTA</h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {prioridades.map((p) => (
          <div key={p.label} className={`p-3 rounded-lg border-l-2 ${p.color}`}>
            <div className="flex items-center gap-2 mb-1">
              <i className={`${p.icon} ${p.iconColor} text-xs`}></i>
              <span className={`text-xs font-medium ${p.textColor}`} title={p.label}>{p.label}</span>
            </div>
            <p className="text-lg font-bold text-foreground-900 ml-5">{p.count}</p>
          </div>
        ))}
      </div>
    </div>
  );
}